import type { DisplayName } from 'api/meta/entities/DisplayName';

export type GetDisplayName = (names: DisplayName[], options?: { language?: string; fallbackName?: string }) => string;

export function getDisplayName(
  names: DisplayName[] = [],
  options?: {
    language?: string;
    fallbackName?: string;
  }
) {
  const language = options?.language || 'en';
  const fallbackName = options?.fallbackName || '';

  return names.find((name) => name.languageCode === language)?.value || fallbackName;
}

/**
 * Display name for a blueprint node type: its English display name, falling back to its technical
 * name. Node types are not guaranteed to carry an English display name, and every surface that lists
 * them needs the same fallback — call this rather than repeating the options object per call site.
 */
export function getNodeTypeName(node: { displayNames: DisplayName[]; technicalName: string }): string {
  return getDisplayName(node.displayNames, { fallbackName: node.technicalName });
}
